<template>
  <div class="h5-sort-filter">
    <div
      v-for="option in options"
      class="h5-sort-filter-item"
      :class="{
        'h5-sort-filter-item--active': hasSort(option.value) || option.value === sort
      }"
      @click="onItemClick(option)"
    >
      {{ option.label }}
      <div
        class="h5-sort-filter-item__right"
        v-if="option.sortable"
      >
        <Icon
          class="h5-sort-filter-item__icon h5-sort-filter-item__icon--up"
          :class="{
            'h5-sort-filter-item__icon--active': sort?.[option.value] === 'asc'
          }"
          name="triangle-right-s"
        />
        <Icon
          class="h5-sort-filter-item__icon h5-sort-filter-item__icon--down"
          :class="{
            'h5-sort-filter-item__icon--active': sort?.[option.value] === 'desc'
          }"
          name="triangle-right-s"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'

const options = [
  {
    value: null,
    label: 'Best Match'
  },
  {
    value: 'monthSold',
    label: 'Bestselling'
  },
  {
    value: 'price',
    label: 'Price',
    sortable: true
  }
]

const sort = defineModel('sort', { type: Object, default: () => ({}) })

const hasSort = (key) => {
  if (sort.value == null) return false
  return Reflect.has(sort.value, key)
}

const onItemClick = (option) => {
  if (option.value == null) sort.value = null
  else {
    const currentValue = sort.value?.[option.value]
    sort.value = { [option.value]: option.sortable ? (currentValue === 'asc' ? 'desc' : 'asc') : 'desc' }
  }
}
</script>

<style lang="less" scoped>
.h5-sort-filter {
  display: flex;
  align-items: center;
  gap: 8px;

  &-item {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    padding: 0 12px 0 16px;
    border-radius: 18px;
    background: #F8F8F8;
    font-family: mon-600;
    font-size: 12px;
    color: #232323;
    cursor: pointer;

    &--active {
      color: #ffffff;
      background: #232323;
    }

    &__right {
      display: flex;
      flex-direction: column;
    }

    &--active &__icon {
      opacity: 0.5;
    }

    &--active &__icon--active {
      opacity: 1;
      color: #ffffff;
    }

    &__icon {
      font-size: 8px;
      color: #b2b7c2;

      &--up {
        transform: rotate(-90deg);
      }

      &--down {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
